import { CkeckColor } from "hooks/layout-hooks"
import { useEffect, useState } from "react"
import { ConvertMiladiToJalali } from "utils/layout-utils"


export const StatementStatistics = ({ metrics, statics, trades }: any) => {
    const [countOfSell, setCountOfSell] = useState<number>(0)
    const [countOfBuy, setCountOfBuy] = useState<number>(0)
    const [maxSymbol, setMaxSymbol] = useState<any>('')
    const [minSymbol, setMinSymbol] = useState<any>('')

    useEffect(() => {
        if (metrics?.numberOfTradePerSymbol) {
            let minKey = Object.keys(metrics?.numberOfTradePerSymbol)[0];
            let minValue: any = Object.values(metrics?.numberOfTradePerSymbol)[0];
            let maxKey = '';
            let maxValue = 0;
            let item: any;
            for (item of Object.entries(metrics?.numberOfTradePerSymbol)) {
                if (item[1] < minValue) {
                    minValue = item[1]
                    minKey = item[0]
                }
                else if (item[1] >= maxValue) {
                    maxValue = item[1]
                    maxKey = item[0]
                }
            }
            setMaxSymbol(maxKey)
            setMinSymbol(minKey)
        }
    }, [metrics])

    useEffect(() => {
        if (trades) {
            let buy = 0;
            let sell = 0;
            for (let i of trades) {
                if (i.order_type != 'balance') {
                    if (i.order_type == 'buy') {
                        buy++;
                    }
                    else if (i.order_type == 'sell') {
                        sell++;
                    }
                }
            }
            setCountOfSell(sell)
            setCountOfBuy(buy)
        }
    }, [trades])

    return (
        <>
            <div className="md:w-[35%] w-full md:pl-2 pl-0">
                <div className="flex flex-col w-full px-3 py-4 rounded-md bg-trade-50">
                    <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>بالانس ابتدای حساب</span>
                        <span>{statics?.last_traded_day?.firstBalanceOfDay}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span> بالانس فعلی </span>
                        <span>{statics?.last_traded_day?.lastBalanceOfDay}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>مقدار سود و زیان </span>
                        <span>{metrics?.lostTrades}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span> تعداد معاملات</span>
                        {/* <span>{ConvertMiladiToJalali(metrics?.bestTradeDate)}</span> */}
                        <span>{metrics?.trades}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>تعداد معاملات فروش </span>
                        {/* <span>{ConvertMiladiToJalali(metrics?.worstTradeDate)}</span> */}
                        <span>{countOfSell}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>تعداد معاملات خرید</span>
                        <span>{countOfBuy}</span>
                    </div>
                </div>
            </div>

            <div className="md:w-[35%] w-full md:px-1 px-0">
                <div className="w-full px-3 py-4 rounded-md bg-trade-50">
                    <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>نماد با بیشترین معامله </span>
                        <span>{maxSymbol}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>نماد با کمترین معامله </span>
                        <span>{minSymbol}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>کل حجم معامله شده (لات)</span>
                        <span>{metrics?.lots.toFixed(2)}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>بزرگترین حجم (لات)</span>
                        <span>{metrics?.maxLots}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>بیشترین سود </span>
                        <span>{CkeckColor(metrics?.bestTrade , '$')}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>بیشترین زیان</span>
                        <span>{CkeckColor(metrics?.worstTrade , '$')}</span>
                    </div>
                </div>
            </div>


            <div className="md:w-[30%] w-full md:pr-2 pr-0">
                <div className="w-full px-3 py-4 rounded-md bg-trade-50">
                    <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>تعداد ضررهای متوالی </span>
                        <span>{metrics?.maxConsecutiveProfitsAndLosses?.maxConsecutiveLosses ? metrics.maxConsecutiveProfitsAndLosses.maxConsecutiveLosses?.toFixed(2) : '———'}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span> تعداد سود متوالی</span>
                        <span>{metrics?.maxConsecutiveProfitsAndLosses?.maxConsecutiveProfit ? metrics?.maxConsecutiveProfitsAndLosses?.maxConsecutiveProfit?.toFixed(2) : '———'}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>Profit  Factor</span>
                        <span>{CkeckColor(metrics?.profitFactor?.toFixed(2))}</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>Sharpe Ratio</span>
                        <span>00.00</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>Sortino Ratio</span>
                        <span>00.00</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>z Score</span>
                        <span>00.00</span>
                    </div>
                </div>
            </div>
        </>
    )
}